<template>
    <div class="app-loader">
        <img src="/img/motif-progress-loader.svg"  alt="Loading....">
        <p>Loading...</p>
        <div class="app-loader__message" v-if="message">{{ message }}</div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            default: null
        }
    }
}
</script>
